import type { App } from 'vue'
import { t } from '@/utils/helpers/translate'

export default {
  install(app: App): void {
    app.config.globalProperties.$t = t
  },
}
